/* eslint-disable no-console */
import { all } from "redux-saga/effects";
import socket from "./socket";
import tenant from "./TenantSagas";
import formSaga from "./form";
import farm from "./FarmSagas";
import listing from "./ListingSagas";
import bidDetails from "./BidDetailsSagas";
import estimate from "./EstimateSagas";
import estimateOverview from "./EstimateOverviewSagas";
import audit from "./AuditSagas";
import auth from "./AuthSagas";

export default function* root() {
  try {
    yield all([
      ...formSaga(),
      ...socket(),
      ...auth(),
      ...tenant(),
      ...farm(),
      ...listing(),
      ...bidDetails(),
      ...estimate(),
      ...estimateOverview(),
      ...audit(),
    ]);
  } catch (e) {
    console.log(e);
  }
}
